import 'reflect-metadata';
import type {JSX} from '@stencil/core';
import type {AbstractGuidedUiElement} from '../models/Guided.schema';
import type {GuidedV2FactoryState} from '../models/ui';


type ct<T> = (inputData: T, state: GuidedV2FactoryState) => JSX.Element;


export const typeRegistry: Record<string, ct<AbstractGuidedUiElement>> = {};



/**
 * Decorator to register a component type in the type registry
 * Guided uses this registry to map widgets from config schema to ui components
 * @param type
 * @constructor
 */
export function RegisterType(type: string) {
    return function (_target, _propertyKey, descriptor) {
        typeRegistry[type] = descriptor.value;
    };
}
